import { CommentsoldIntegrationProduct } from "@redotech/redo-integrations-definitions-common/commentsold";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createCommentsoldIntegration = {
  name: "createCommentsoldIntegration" as const,
  input: z.object({
    product: createEnum(CommentsoldIntegrationProduct),
    shop: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
